import dataPanelLightIcon from "../../images/icons/light/data-panel-icon.svg";
import dataPanelDarkIcon from "../../images/icons/dark/data-panel-icon.svg";
import financeLightIcon from "../../images/icons/light/finance-icon.svg";
import financeDarkIcon from "../../images/icons/dark/finance-icon.svg";
import sellingsLightIcon from "../../images/icons/light/sellings-icon.svg";
import sellingsDarkIcon from "../../images/icons/dark/sellings-icon.svg";
import clientsLightIcon from "../../images/icons/light/clients-icon.svg";
import clientsDarkIcon from "../../images/icons/dark/clients-icon.svg";
import companiesLightIcon from "../../images/icons/light/company-icon.svg";
import companiesDarkIcon from "../../images/icons/dark/company-icon.svg";
import tasksLightIcon from "../../images/icons/light/tasks-icon.svg";
import tasksDarkIcon from "../../images/icons/dark/tasks-icon.svg";
import projectsLightIcon from "../../images/icons/light/projects-icon.svg";
import projectsDarkIcon from "../../images/icons/dark/projects-icon.svg";
import settingsLightIcon from "../../images/icons/light/setting-icon.svg";
import settingsDarkIcon from "../../images/icons/dark/setting-icon.svg";

import { HeadlineTypeEnum } from "../enums/headline";

export const panelItems = [
  {
    id: "data-panel",
    name: "Панель даних",
    icons: [dataPanelLightIcon, dataPanelDarkIcon],
  },
  {
    id: "finance",
    name: "Фінанси",
    icons: [financeLightIcon, financeDarkIcon],
  },
  {
    id: "selling",
    name: "Продажі",
    icons: [sellingsLightIcon, sellingsDarkIcon],
  },
  {
    id: "clients",
    name: "Клієнти",
    icons: [clientsLightIcon, clientsDarkIcon],
  },
  {
    id: "companies",
    name: "Компанії",
    icons: [companiesLightIcon, companiesDarkIcon],
  },
  {
    id: "tasks",
    name: "Завдання",
    icons: [tasksLightIcon, tasksDarkIcon],
  },
  {
    id: "projects",
    name: "Проєкти",
    icons: [projectsLightIcon, projectsDarkIcon],
  },
  {
    id: "settings",
    name: "Налаштування",
    icons: [settingsLightIcon, settingsDarkIcon],
  },
];

export const headlineItems = {
  [HeadlineTypeEnum.PANEL]: {
    headline: "Панель даних",
    icon: [dataPanelLightIcon, dataPanelDarkIcon],
  },
  [HeadlineTypeEnum.CLIENTS]: {
    headline: "Клієнти",
    icon: [clientsLightIcon, clientsDarkIcon],
  },
  [HeadlineTypeEnum.COMPANIES]: {
    headline: "Компанії",
    icon: [companiesLightIcon, companiesDarkIcon],
  },
  [HeadlineTypeEnum.PROJECTS]: {
    headline: "Проєкти",
    icon: [projectsLightIcon, projectsDarkIcon],
  },
  [HeadlineTypeEnum.TASKS]: {
    headline: "Завдання",
    icon: [tasksLightIcon, tasksDarkIcon],
  },
  [HeadlineTypeEnum.SETTINGS]: {
    headline: "Налаштування",
    icon: [settingsLightIcon, settingsDarkIcon],
  },
  [HeadlineTypeEnum.SELLING]: {
    headline: "Продажі",
    icon: [sellingsLightIcon, sellingsDarkIcon],
  },
    [HeadlineTypeEnum.FINANCE]: {
    headline: "Фінанси",
    icon: [financeLightIcon, financeDarkIcon],
  },
};
